var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 14C19.9081 14.064 18.0001 16.083 18.0001 17.5C18.0001 18.994 18.9491 19.948 20.0001 20C20.9061 20.044 22.0001 19.109 22.0001 17.5C22.0001 16 20.0921 14.064 20.0001 14ZM9.58606 20C9.96406 20.378 10.4661 20.586 11.0001 20.586C11.5341 20.586 12.0361 20.378 12.4141 20L19.4141 13L18.7071 12.293L11.0001 4.58597L8.70706 2.29297L7.29306 3.70697L9.58606 5.99997L4.00006 11.586C3.62206 11.964 3.41406 12.466 3.41406 13C3.41406 13.534 3.62206 14.036 4.00006 14.414L9.58606 20ZM11.0001 7.41397L16.5861 13H5.41406L11.0001 7.41397Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillColorIcon);
export default __webpack_public_path__ + "static/media/fillColorIcon.6a42e7be04b14402285625d010bcb20e.svg";
export { ForwardRef as ReactComponent };